export default __webpack_public_path__ + "static/Online-Shopping-a93e8bfd59f144b9966231ba9549e0e9.webp";